(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('[data-savee-shuffle]').forEach((rail) => {
    const cards = [...rail.children];
    for (let i = cards.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [cards[i], cards[j]] = [cards[j], cards[i]];
    }
    cards.forEach((card) => rail.appendChild(card));
  });

  /* Rails are manually scrolled only — no auto-advance. */

  const prepareVideo = (video) => {
    video.muted = true;
    video.playsInline = true;
  };

  const videos = [...document.querySelectorAll('.savee-home video')];

  if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting && !reducedMotion.matches) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { rootMargin: '160px 0px', threshold: 0.08 });

    videos.forEach((video) => {
      prepareVideo(video);
      videoObserver.observe(video);
    });
  } else {
    videos.forEach((video) => {
      prepareVideo(video);
      video.play().catch(() => {});
    });
  }
})();
